package com.nonopn.skywatcher.design.widgets.abslists

data class SectionListModelStateHolder<H, E>(
    val state: ListModelState = ListModelState.DEFAULT,
    val objects: List<Section<H, E>> = emptyList(),
    val predicate: ((section: Section<H, E>) -> Section<H, E>)? = null,
    val filtered: List<Section<H, E>> = emptyList()
)
